import Dashboard from "@/pages/Dashboard";
import Sell from "@/pages/Sell";
import Inventory from "@/pages/Inventory";
import History from "@/pages/History";
import Debts from "@/pages/Debts";
import Subscription from "@/pages/Subscription";
import Referrals from "@/pages/Referrals";
import Expenses from "@/pages/Expenses";
import Credits from "@/pages/Credits";
import Wallet from "@/pages/Wallet";

export const CORE_WORKSPACE_ROUTES = [
  { path: "/dashboard", element: Dashboard, permission: "analytics" },
  { path: "/sell", element: Sell, permission: "sell" },
  { path: "/inventory", element: Inventory, permission: "inventory" },
  { path: "/inventory/new", element: Inventory, permission: "inventory" },
  { path: "/inventory/:productId", element: Inventory, permission: "inventory" },
  { path: "/inventory/:productId/edit", element: Inventory, permission: "inventory" },
  { path: "/inventory/:productId/stock", element: Inventory, permission: "inventory" },
  { path: "/inventory/:productId/allocation", element: Inventory, permission: "inventory" },
  { path: "/inventory/:productId/transactions", element: Inventory, permission: "inventory" },
  { path: "/inventory/:productId/profit", element: Inventory, permission: "inventory" },
  { path: "/history", element: History, permission: "history" },
  { path: "/history/:saleId", element: History, permission: "history" },
  { path: "/debts", element: Debts, permission: "debts" },
  { path: "/expenses", element: Expenses, permission: "expenses" },
  { path: "/credits", element: Credits, permission: "billing" },
  { path: "/subscription", element: Subscription, permission: "billing" },
  { path: "/referrals", element: Referrals, role: "Owner" },
  { path: "/wallet", element: Wallet, permission: "billing" },
];
